export default __webpack_public_path__ + "static/media/Ivaylo.9992ccc9.png";